import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { ContactOutput } from '../model/contact.output';

export interface RemoveContactColumnInput {
	readonly id: string;
	readonly moduleId: string;
}

export interface RemoveContactColumnParams {
	input: RemoveContactColumnInput;
}

@Injectable({ providedIn: 'root' })
export class RemoveContactColumnApiMutation extends ApiMutation<
	ContactOutput,
	RemoveContactColumnParams
> {
	client = 'iam';
	document = gql`
		mutation RemoveContactColumn($input: RemoveContactColumnInput!) {
			removeContactColumn(input: $input) {
				...Contact
			}
		}
		${contact}
	`;
	method = 'removeContactColumn';
}
